import React, { useEffect, useState } from 'react';

import { fetchLoginExpiredCandidates } from '../../services/user/api';

import { RotateCcw, Trash2 , Search } from 'lucide-react';

import '../../styles/user/loginExpiredCandidates.css';
 
const LoginExpiredCandidatesPage = () => {

  const [candidates, setCandidates] = useState([]);

  const [search, setSearch] = useState('');

  const [currentPage, setCurrentPage] = useState(1);

  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const [totalElements, setTotalElements] = useState(0);

  const [loading, setLoading] = useState(true);
 
  const startIndex = (currentPage - 1) * entriesPerPage;

  const totalPages = Math.ceil(totalElements / entriesPerPage);
 
  useEffect(() => {

    loadCandidates(currentPage - 1, entriesPerPage); // backend is 0-indexed

  }, [currentPage, entriesPerPage]);
 
  const loadCandidates = async (page, size) => {

    try {

      setLoading(true);

      const res = await fetchLoginExpiredCandidates(page, size);

      const pageData = res.data.data;
 
      //  Fix: assign correct values

      setCandidates(pageData.content || []);

      setTotalElements(pageData.totalElements || 0);

    } catch (error) {

      console.error('Failed to fetch candidates', error);

    } finally {

      setLoading(false);

    }

  };
 
  const filtered = candidates.filter((c) =>

    c.fullname?.toLowerCase().includes(search.toLowerCase())

  );
 
  return (
<>
<p className="client-header">Login Expired Candidates</p>
 
    <div className="client-wrapper">
 
      <div className="clinet-table-controls">
<div className="entries-select">

          Show{' '}
<select

            value={entriesPerPage}

            onChange={(e) => {

              setEntriesPerPage(parseInt(e.target.value));

              setCurrentPage(1);

            }}
>
<option value="10">10</option>
<option value="25">25</option>
<option value="50">50</option>
</select>{' '}

          entries
</div>
<div className="client-search-box">

  {/* <label htmlFor="client-search-input">Search:</label> */}
<div className="client-search-input-wrapper">
<input

      id="client-search-input"

      type="text"

      value={search}

      onChange={(e) => {

        setSearch(e.target.value);

        setCurrentPage(0);

      }}

      placeholder="Search by name"

    />
<Search className="client-search-icon" size={18} />
</div>
</div>
</div>
 
      <div className="clinet-table-container">
<table className="candidates-clinet-table">
<thead>
<tr>
<th>Unique ID</th>
<th>Name</th>
<th>Email</th>
<th>Mobile Number</th>
<th>DOB</th>
<th>Case Initiated Date</th>
<th>Case Initiated Time</th>
</tr>
</thead>
<tbody>

            {loading ? (
<tr>
<td colSpan="7" className="no-data">Loading...</td>
</tr>

            ) : filtered.length > 0 ? (

              filtered.map((candidate) => (
<tr key={candidate.candidateid}>
<td>{candidate.candidateid}</td>
<td>{candidate.fullname}</td>
<td>{candidate.email}</td>
<td>{candidate.mobileNumber}</td>
<td>{candidate.dateOfBirth}</td>
<td>{candidate.caseInitiatedDateOnlyAsString || '---'}</td>
<td>{candidate.caseInitiatedTimeOnly || '---'}</td>
</tr>

              ))

            ) : (
<tr>
<td colSpan="7" className="no-data">No matching candidates found.</td>
</tr>

            )}
          </tbody>
        </table>
      </div>

<div className="pagination">
  <div className="pagination-summary">
    <span>
      Showing {totalElements === 0 ? 0 : startIndex + 1} to{' '}
      {Math.min(startIndex + filtered.length, totalElements)} of {totalElements} entries
    </span>
  </div>

  {totalPages > 1 && (
    <div className="pagination-buttons-user">
      {/* Previous button */}
<button

        className="page-btn"

        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}

        disabled={currentPage === 1}
>

        ←
      </button>

      {/* Current page */}
      <button
        className={`page-btn ${currentPage === currentPage ? 'active' : ''}`}

        onClick={() => setCurrentPage(currentPage)}
>

        {currentPage}
      </button>

      {/* Next page if available */}
      {currentPage < totalPages && (
<button

          className="page-btn"

          onClick={() => setCurrentPage(currentPage + 1)}
>

          {currentPage + 1}
</button>

      )}
 
      {/* Next button */}
<button

        className="page-btn"

        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}

        disabled={currentPage === totalPages}
>

        →
      </button>
    </div>
  )}
</div>

    </div>
</>

  );

};
 
export default LoginExpiredCandidatesPage;

 